import React, { useContext } from "react";

import BusinessView from "../components/BusinessView";
import { ConfigContext } from "../context/GlobalContext";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerView from "../components/CustomerView";

const CustomerViewPage = ({ }) => {
  const { state } = useContext(ConfigContext);


  return (
    <>
      <MasterLayout>
        <CustomerView state={state} />
      </MasterLayout></>

  );
};

export default CustomerViewPage;
